import { jsx as n, jsxs as G } from "react/jsx-runtime";
import { useId as b, useMemo as t } from "react";
import { useMultiStyleConfig as p, Flex as c } from "@chakra-ui/react";
import { GlobalFooterMainContainer as C } from "./GlobalFooterMainContainer.mjs";
import { GlobalFooterContext as u } from "./GlobalFooterContext.mjs";
import { GlobalFooterTopContainer as x } from "./GlobalFooterTopContainer.mjs";
import { findChild as r } from "../../../utils/findChild.mjs";
const j = ({ children: o, copyright: i = "SGI", id: e }) => {
  const s = e || `gravity-footer-${b()}`, m = p("GlobalFooter"), f = t(() => r(o, "GlobalFooterSocials"), [o]), F = t(() => r(o, "GlobalFooterMainLinks"), [o]), l = t(() => r(o, "GlobalFooterContent1"), [o]), a = t(() => r(o, "GlobalFooterContent2"), [o]);
  return /* @__PURE__ */ n(u.Provider, { value: { rootId: s }, children: /* @__PURE__ */ G(c, { as: "footer", id: s, sx: m.container, children: [
    (l || a) && /* @__PURE__ */ n(x, { content1: l, content2: a }),
    /* @__PURE__ */ n(C, { copyright: i, socials: f, links: F })
  ] }) });
};
export {
  j as GlobalFooter
};
